// The aligner's chord table, which its Registry takes in place of the shell's (src/core/chords.ts);
// src/core/bindings.ts reads a chord from it. The default chord for every command, per platform.
// The one place a key is named. A chord is modifiers and a key joined by `+`: `Mod+Shift+A`,
// `Enter`, `Mod+Alt+Down`. `Mod` is Cmd on a Mac and Ctrl elsewhere. A string binds both platforms;
// an object binds each.
//
// The keymap the user approved on 2026-11-01 (docs/design/aligner/decisions.md, decision 13). The
// rule for choosing a chord: taking a browser shortcut people rarely use is fine (Mod+J, Mod+K,
// Mod+O, Mod+S, Mod+E, Mod+Shift+A); one people use often (Mod+L, Mod+G, Mod+T, tab switching) or
// one the system takes first (screenshots, input-source switching) is not; a system-wide or
// text-editing chord with strong muscle memory is not reused. Where a command means what one of the
// main app's commands means, it takes the main app's chord (the palette, undo and redo, the
// shortcuts sheet, next flagged as the next untranslated Segment, lock and realign as approve, join
// with next); no main-app chord is used for another meaning, so Mod+Shift+K (completion there)
// stays free. docs/design/aligner/keyboard-shortcuts.md has every chord's class.
//
// Join needs another key on Windows and Linux. The main app's join there is Alt+Down, which moves a
// sentence down here, and Ctrl+Alt is AltGr on international keyboards, so join is Alt+J: free in
// every table there, and the shell's way of dropping Mod from a Mac's Mod+Alt chord (Alt+T, Alt+B).
//
// The file chords, Mod+O and Mod+S, are taken from the browser here: the aligner has no native menu
// bar to give them to. Pinpoint Align, Export TMX and Lock without realigning have no chord; the
// toolbar, the menus and the palette run them. Exclude's Mod+Backspace acts in the grid only: while
// a cell's text is being edited the keymap leaves every key to the edit box.

import { chordTable } from '../../core/bindings.ts'

export const CHORDS = chordTable({
  'palette.open': 'Mod+K',
  'session.open': 'Mod+O',
  'session.save': 'Mod+S',
  'edit.undo': 'Mod+Z',
  'edit.redo': { mac: 'Mod+Shift+Z', windows: 'Mod+Y' },
  'cell.edit': 'Mod+E',
  'row.split': 'Mod+Enter',
  'row.join': { mac: 'Mod+Alt+Down', windows: 'Alt+J' },
  'row.moveUp': 'Alt+Up',
  'row.moveDown': 'Alt+Down',
  'row.lockRealign': 'Mod+Shift+A',
  'row.exclude': 'Mod+Backspace',
  'row.nextFlagged': 'Mod+J',
  'shortcuts.open': 'Mod+Slash',
})
